import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { getPoolOwner } from 'modules/pool/methods/getPoolOwner';

interface IGetPoolOwnerArgs {
  address: Address;
}

export const {
  useGetPoolOwnerQuery,
  endpoints: { getPoolOwner: getPoolOwnerEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getPoolOwner: build.query<Address, IGetPoolOwnerArgs>({
      queryFn: async ({ address }) => {
        try {
          const client = getPublicClient();

          return { data: await getPoolOwner(client, address) };
        } catch {
          const client = getPublicClient();

          return { data: await getPoolOwner(client, address) };
        }
      },
      providesTags: [cacheTags.pools],
    }),
  }),
});
